import InfoRounded from '@mui/icons-material/InfoRounded';
import { FormHelperText } from '@mui/material';
import { FC } from 'react';

type Props = {
  text: string;
};

const InfoLine: FC<Props> = ({ text }) => (
  <FormHelperText sx={{ mt: 0 }}>
    <InfoRounded sx={{ width: '16px', height: '16px', verticalAlign: 'middle' }} />
    <span style={{ verticalAlign: 'middle', marginLeft: '4px' }}>{text}</span>
  </FormHelperText>
);

export default InfoLine;
